import { useNuxtApp } from 'nuxt/app';
import { setUserServiceAxiosAccessToken } from '~/plugins/user-service-axios.ts';

export default defineNuxtRouteMiddleware(async(to) => {
  const allowedPaths = ['/login', '/ticket-box'];
  if (!allowedPaths.some((path) => to.path.startsWith(path))) {
    const { $auth } = useNuxtApp();
    const token = await $auth.getToken(true);

    if (token === null) {
      const query = to.query as { [name: string]: string | string[] };
      $auth.setRestoreUrl(to.path, query);
      return navigateTo('/login');
    } else {
      setUserServiceAxiosAccessToken(token);

      const { onLogin } = useApollo();
      await onLogin(token);
    }
  }
});

